import React, { useState } from 'react';
import { AlertTriangle, Mail, RotateCcw } from 'lucide-react';
import { Button } from '../../ui/button';
import { Checkbox } from '../../ui/checkbox';

const describe = (s) => s.provider === 'resend'
  ? `${s.from_name} <${s.sender_email}> via Resend${s.reply_to ? ` · Reply-To ${s.reply_to}` : ''}`
  : `the platform default sender (name "${s.from_name}")`;

export const ActiveSender = ({ d, onRollback }) => {
  const [ok, setOk] = useState(false);
  if (d.setup_required) {
    return (
      <div className="border border-amber-300 bg-amber-50 rounded-lg p-5 flex gap-3" data-testid="email-setup-required">
        <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0" />
        <div><p className="font-semibold">Email setup required</p>
          <p className="text-sm text-neutral-600">No active sender yet, so customer emails are not being sent. Fill in the new sender below, pass every check and click Activate New Sender.</p></div>
      </div>
    );
  }
  const a = d.active;
  return (
    <div className="bg-white border rounded-lg p-5 space-y-3" data-testid="email-active-card">
      <p className="text-xs uppercase tracking-wide text-neutral-500 flex items-center gap-1"><Mail className="w-3.5 h-3.5" />Active sender (live)</p>
      <p className="text-sm" data-testid="email-active-sender">Customer emails are sent by: <b>{describe(a)}</b></p>
      <p className="text-xs text-neutral-500">
        Domain {a.sending_domain || '—'} · API key {a.key_hint || '—'} · active since {a.activated_at?.slice(0, 16).replace('T', ' ')} by {a.activated_by}
      </p>
      {d.previous && (
        <div className="flex flex-wrap items-center gap-3 pt-2 border-t" data-testid="email-rollback-panel">
          <label className="flex items-center gap-2 text-xs"><Checkbox checked={ok} onCheckedChange={(v) => setOk(!!v)} data-testid="email-rollback-confirm" />Go back to {describe(d.previous)}</label>
          <Button size="sm" variant="outline" disabled={!ok} onClick={() => onRollback().then(() => setOk(false))} data-testid="email-rollback"><RotateCcw className="w-4 h-4 mr-1" />Roll back</Button>
        </div>
      )}
    </div>
  );
};
